module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_469824058_L-f3e011c53de32d855d73eae5e3565af7.jpg";